import { Route, Routes } from "react-router-dom"

import ListarProyectos from "./ListarProyectos"
import GestionarProyecto from "./GestionarProyecto"


const ProyectosRoutes = () => (
    <Routes>
        <Route path=":Slug" Component={GestionarProyecto} />
        <Route path="/" Component={ListarProyectos} />
    </Routes>
)

export default ProyectosRoutes